import { connect } from 'react-redux';
import Description from '../../components/metadata/description';

import { toggleMediaDescription, showMediaDescription } from '../../actions/ui';

const mapStateToProps = function(state) {
	return {
		media: state.media.item,
		expanded: state.ui.show_media_description === true
	};
}

const mapDispatchToProps = function(dispatch) {
	return {
		toggleMediaDescription: ()=>dispatch(toggleMediaDescription()),
		showMediaDescription: (visible)=>dispatch(showMediaDescription(visible))
	};
}

const DescriptionContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(Description)

export default DescriptionContainer;